import React, { useState, useEffect } from 'react';
import { agentRealisateur, VOIX_IA } from '../services/aiService';
import { VideoEngine } from '../services/VideoEngine';

const WORKER = 'https://contenuia-proxy.soihibaliousseni.workers.dev';

const AgentPage: React.FC = () => {
  const [titre, setTitre] = useState('');
  const [produit, setProduit] = useState('ContenuIA');
  const [duree, setDuree] = useState('30');
  const [voix, setVoix] = useState('fr-femme-1');
  const [langue] = useState('Français');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [, setVideoBlob] = useState<Blob | null>(null);
  const [toast, setToast] = useState('');
  const show = (m: string) => { setToast(m); setTimeout(() => setToast(''), 3500); };

  useEffect(() => {
    const t = localStorage.getItem('agent_titre');
    if (t) { setTitre(t); localStorage.removeItem('agent_titre'); }
    const handler = (e: any) => { if (e.detail === 'agent') {} };
    window.addEventListener('navigate', handler);
    return () => window.removeEventListener('navigate', handler);
  }, []);

  const handle = async () => {
    if (!titre) { show('⚠️ Donne un titre'); return; }
    setLoading(true); setStep('🤖 Analyse du titre...'); setResult(null); setVideoUrl('');
    try {
      setStep('✍️ Script + score viral...');
      const res = await agentRealisateur({ titre, produit, duree, langue });
      setResult(res);
      setStep('🔊 Voix IA...');
      const v = VOIX_IA[voix];
      const ttsRes = await fetch(WORKER + '/tts', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text: res.script.replace(/\[.*?\]/g, '').substring(0, 800), languageCode: v.languageCode, voiceName: v.voiceName }) });
      const ttsData = await ttsRes.json();
      if (!ttsData.audioContent) throw new Error('Voix IA échouée');
      setStep('🎬 Vidéo Pexels...');
      const q = produit + ' business professional';
      const vRes = await fetch(WORKER + '/pexels-video?q=' + encodeURIComponent(q) + '&page=' + (Math.floor(Math.random() * 8) + 1));
      const vData = await vRes.json();
      if (!vData.url) throw new Error('Pas de vidéo');
      setStep('🎞️ Fusion vidéo + voix + sous-titres...');
      const proxyUrl = WORKER + '/proxy-video?url=' + encodeURIComponent(vData.url);
      const output = await VideoEngine.render({ backgroundVideoUrl: proxyUrl, audioB64: ttsData.audioContent, scriptForSubtitles: res.script, branding: { nom: produit, couleur: '#6C47FF', afficherUrl: 'contenuia.pages.dev' }, onProgress: (s, p) => setStep(s + ' ' + p + '%') });
      setVideoBlob(output.blob); setVideoUrl(output.url);
      show('✅ Vidéo complète prête !');
    } catch (e: any) { show('⚠️ ' + e.message); }
    setLoading(false); setStep('');
  };

  const scoreColor = (s: number) => s >= 80 ? '#00F5A0' : s >= 60 ? '#FFB300' : '#FF4444';
  const inp: React.CSSProperties = { width: '100%', background: '#252540', border: '1px solid #3A3A5C', borderRadius: 10, padding: '12px 14px', color: '#F8F7FF', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ padding: 32 }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 6 }}>🤖 Agent IA Réalisateur</div>
      <div style={{ color: '#C8C8E8', fontSize: 14, marginBottom: 28 }}>Titre → Script → Voix → Vidéo — automatiquement</div>
      <div style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 20, padding: 24, marginBottom: 20 }}>
        <label style={{ display: 'block', fontSize: 13, color: '#FF4444', fontWeight: 700, marginBottom: 6 }}>🎯 Titre de la vidéo *</label>
        <input style={{ ...inp, border: '2px solid rgba(255,68,68,0.4)', fontSize: 16, marginBottom: 14 }} value={titre} onChange={e => setTitre(e.target.value)} placeholder='ex: "Cette IA crée des vidéos pendant que tu travailles"' />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <div><label style={{ fontSize: 12, color: '#C8C8E8', display: 'block', marginBottom: 4 }}>Produit</label><input style={inp} value={produit} onChange={e => setProduit(e.target.value)} /></div>
          <div><label style={{ fontSize: 12, color: '#C8C8E8', display: 'block', marginBottom: 4 }}>Voix</label><select style={inp} value={voix} onChange={e => setVoix(e.target.value)}>{Object.entries(VOIX_IA).map(([k, v]) => <option key={k} value={k}>{v.emoji} {v.label}</option>)}</select></div>
          <div><label style={{ fontSize: 12, color: '#C8C8E8', display: 'block', marginBottom: 4 }}>Durée</label><select style={inp} value={duree} onChange={e => setDuree(e.target.value)}><option value="15">15s</option><option value="30">30s</option><option value="60">60s</option></select></div>
        </div>
        <button onClick={handle} disabled={loading} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '16px', background: loading ? '#3A3A5C' : 'linear-gradient(135deg,#6C47FF,#8B6FFF)', border: 'none', borderRadius: 14, color: '#FFF', fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', width: '100%', marginTop: 16 }}>
          {loading ? step || '⏳...' : '🤖 Lancer l\'Agent'}
        </button>
      </div>
      {result && (
        <div style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 20, padding: 24, marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#F8F7FF' }}>📝 Script</span>
            <span style={{ fontSize: 28, fontWeight: 800, color: scoreColor(result.score) }}>{result.score}/100</span>
          </div>
          <div style={{ fontSize: 14, color: '#C8C8E8', lineHeight: 1.8, whiteSpace: 'pre-wrap', marginBottom: 16 }}>{result.script}</div>
          {videoUrl && <video controls src={videoUrl} style={{ width: '100%', borderRadius: 12, maxHeight: 320 }} />}
        </div>
      )}
      <div style={{ position: 'fixed', bottom: 24, right: 24, background: '#1A1A2E', border: '1px solid #00F5A0', borderRadius: 12, padding: '12px 20px', color: '#00F5A0', zIndex: 2000, fontSize: 13, opacity: toast ? 1 : 0, transition: 'all 0.3s', pointerEvents: 'none' }}>{toast}</div>
    </div>
  );
};
export default AgentPage;
